<script setup lang='ts'>
import { useCarModel } from './hooks'
import { LOAD_STATE } from '~/shared/types'
import type { ModelResponse } from '@/server/types'

const props = withDefaults(defineProps<{
  seriesId?: number
  modelId?: number
}>(), {})
const emits = defineEmits({
  select: (_data: ModelResponse) => true,
})

const {
  loadState,
  yearList,
  modelList,
  getModelList,
} = useCarModel()
function select(data: ModelResponse) {
  emits('select', data)
}

function getData() {
  if (props.seriesId)
    getModelList(props.seriesId)
}

watchEffect(getData)
</script>

<template>
  <div class="car-container">
    <UtilLoadState :state="loadState" :reload-handler="getData">
      <div v-if="modelList && modelList.size" class="car-list">
        <div v-for="key in yearList" :key="key">
          <div class="car-key">
            {{ key }}
          </div>
          <div v-if="modelList.has(key) && modelList.get(key)?.length" class="flex flex-wrap p-3">
            <div
              v-for="item in modelList.get(key)" :key="item.id"
              class="car-item"
              :class="{ active: item.id === modelId }"
              @click="select(item)"
            >
              {{ item.carModelName }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="car-empty">
        <BasicEmpty text="暂无相关车型数据" />
      </div>
    </UtilLoadState>
  </div>
</template>

<style lang='scss' scoped>
@import './index.scss';
</style>
